$(document).ready(function () {
  $(window).scroll(function () {
    if ($(this).scrollTop() > 90) {
      $("#header").addClass("sticky-header");
    } else {
      $("#header").removeClass("sticky-header");
    }
  });
function initBestSellerSlider() {

  if ($(window).width() > 767) {

    if (!$(".best-seller-slider").hasClass("owl-loaded")) {

      $(".best-seller-slider").owlCarousel({
        loop: true,
        margin: 26,
        nav: true,
        dots: false,
        navText: [
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"/></svg>',
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"/></svg>'
        ],
        responsive: {
          768: {
            items: 2
          },
          1024: {
            items: 3
          },
          1140: {
            items: 4
          }
        }
      });

    }

  } else {

    if ($(".best-seller-slider").hasClass("owl-loaded")) {
      $(".best-seller-slider").trigger("destroy.owl.carousel");
      $(".best-seller-slider")
        .removeClass("owl-carousel owl-loaded");

      $(".best-seller-slider .owl-stage-outer").children().unwrap();
      $(".best-seller-slider .owl-stage").children().unwrap();
    }

  }

}

initBestSellerSlider();

$(window).on("resize", function () {
  initBestSellerSlider();
});

  
  function initCustomerFavoriteSlider() {

  if ($(window).width() > 767) {

    if (!$(".costomer-favorite-slider").hasClass("owl-loaded")) {

      $(".costomer-favorite-slider").owlCarousel({
        loop: true,
        margin: 26,
        nav: true,
        dots: false,
        navText: [
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"/></svg>',
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"/></svg>'
        ],
        responsive: {
          768: {
            items: 2
          },
          1024: {
            items: 3
          },
          1140: {
            items: 4
          }
        }
      });

    }

  } else {

    if ($(".costomer-favorite-slider").hasClass("owl-loaded")) {

      $(".costomer-favorite-slider").trigger("destroy.owl.carousel");

      $(".costomer-favorite-slider")
        .removeClass("owl-carousel owl-loaded");

      $(".costomer-favorite-slider .owl-stage-outer").children().unwrap();
      $(".costomer-favorite-slider .owl-stage").children().unwrap();
    }

  }

}

initCustomerFavoriteSlider();

$(window).on("resize", function () {
  initCustomerFavoriteSlider();
});

  $(".Related-products-slider").owlCarousel({
    loop: true,
    margin: 26,
    nav: true,
    navText: [
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Free v5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.--><path d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"/></svg>',
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Free v5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.--><path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"/></svg>',
    ],
    dots: false,
    responsive: {
      0: {
        items: 1,
        autoplay: true,
      },
      767: {
        items: 2,
        autoplay: true,
      },
      1024: {
        items: 3,
      },
      1140: {
        items: 4,
      },
    },
  });


$(function () {
  const MAX_TOPPINGS = 3;
 
  // BASE selection (single select)
  $('#base-grid').on('click', '.dream-jar-base-option', function () {
    $('#base-grid .dream-jar-base-option').removeClass('dream-jar-selected');
    $(this).addClass('dream-jar-selected');
    $('#base-badge').text('Selected ✓').css('color', '#27a060');
  });
 
  // TOPPINGS (multi-select up to 3)
  $('#toppings-grid').on('click', '.dream-jar-topping-chip', function () {
    const $chip = $(this);
    const isSelected = $chip.hasClass('dream-jar-selected');
    const currentCount = $('#toppings-grid .dream-jar-topping-chip.dream-jar-selected').length;
 
    if (!isSelected && currentCount >= MAX_TOPPINGS) {
      // Shake the badge
      $('#toppings-badge').addClass('dream-jar-shake');
      setTimeout(() => $('#toppings-badge').removeClass('dream-jar-shake'), 400);
      return;
    }
 
    $chip.toggleClass('dream-jar-selected');
    const newSelected = $chip.hasClass('dream-jar-selected');
    $chip.find('.dream-jar-chip-status').text(newSelected ? 'Selected' : 'Tap to select');
 
    updateToppingsBadge();
  });
 
  function updateToppingsBadge() {
    const count = $('#toppings-grid .dream-jar-topping-chip.dream-jar-selected').length;
    const $badge = $('#toppings-badge');
    $badge.text(count + ' / ' + MAX_TOPPINGS + ' Selected');
    if (count === MAX_TOPPINGS) {
      $badge.css('color', '#27a060');
    } else {
      $badge.css('color', 'var(--coral)');
    }
  }
 
  // CTA Button
  $('#start-btn').on('click', function () {
    const base = $('#base-grid .dream-jar-base-option.dream-jar-selected').data('base');
    if (!base) {
      $('#base-badge').text('Please select a base!').css('color', '#cc2200');
      return;
    }
    const toppings = [];
    $('#toppings-grid .dream-jar-topping-chip.dream-jar-selected').each(function () {
      toppings.push($(this).data('topping'));
    });
 
    const baseNames = {
      peanut: 'Peanut Butter', almond: 'Almond Butter',
      cashew: 'Cashew Butter', chocpeanut: 'Choc Peanut'
    };
 
    alert('🫙 Your Dream Jar:\nBase: ' + baseNames[base] + '\nToppings: ' + (toppings.length ? toppings.join(', ') : 'None yet'));
  });
});














});
